var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":"pipeline-schedule-target"}},[(_vm.refPath)?_c('span',[_c('gl-icon',{attrs:{"name":_vm.iconName}}),_vm._v(" "),_c('gl-link',{staticClass:"gl-text-default",attrs:{"href":_vm.refPath}},[_vm._v(_vm._s(_vm.refDisplay))])],1):_c('span',[_vm._v("\n    "+_vm._s(_vm.s__('PipelineSchedules|None'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }